<template>
  <div id="app">
    <NavigationBar />
      <router-view/>
    <FooTer />
    <!-- <div v-if="fontLoaded">
      <NavigationBar />
      <router-view/>
      <FooTer />
    </div>
    <div v-else>
      <p>Loading...</p>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      fontLoaded: false
    }
  },
  mounted () {
    // this.loadFont()
  },
  methods: {
    // loadFont () {
    //   const font = new FontFace('HarmonyOS_Sans_SC_Regular', 'url(./../assets/fonts/HarmonyOS_Sans_SC/HarmonyOS_Sans_SC_Regular.ttf)')
    //   font.load().then(() => {
    //     // 字体加载完成
    //     this.fontLoaded = true
    //   }).catch((error) => {
    //     console.error('Failed to load font: ', error)
    //   })
    // }
  }
}
</script>

<style lang="scss">
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
